import { downloadZip, makeZip } from "client-zip";

export function downloadUsingATag(url: string, fileName: string) {
  const a = document.createElement("a");
  a.href = url;
  a.download = fileName;

  document.body.appendChild(a);

  a.click();

  document.body.removeChild(a);
}

export async function downloadFromUrl(url: string, fileName: string): Promise<void> {
  try {
    // Fetch the file from the URL
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`Failed to fetch file: ${response.statusText}`);
    }

    // Convert to blob
    const blob = await response.blob();
    const blobUrl = URL.createObjectURL(blob);

    // Create download link
    const a = document.createElement("a");
    a.href = blobUrl;
    a.download = fileName;
    a.style.display = "none";
    document.body.appendChild(a);

    // Cleanup
    window.addEventListener(
      "focus",
      () => {
        URL.revokeObjectURL(blobUrl);
        document.body.removeChild(a);
      },
      { once: true }
    );

    a.click();
  } catch (error) {
    console.error("Error downloading file:", error);
    throw error;
  }
}

export function downloadCsvTextAsFile(filename: string, text: string) {
  var element = document.createElement("a");

  element.setAttribute("id", filename);
  element.setAttribute(
    "href",
    "data:text/csv;charset=utf-8," + encodeURIComponent(text),
  );
  element.setAttribute("download", filename);

  element.style.display = "none";
  document.body.appendChild(element);

  element.click();

  document.body.removeChild(element);
}

export function downloadBinaryData(
  data: any,
  fileName: string,
  mimeType: string,
) {
  const blob = new Blob([data], { type: mimeType });
  const url = URL.createObjectURL(blob);

  const a = document.createElement("a");
  a.href = url;
  a.download = fileName;
  a.style.display = "none";
  document.body.appendChild(a);
  a.click();

  // Cleanup
  window.addEventListener(
    "focus",
    () => {
      URL.revokeObjectURL(url);
      document.body.removeChild(a);
    },
    { once: true },
  );
}

export async function createZipFrom(
  files: File[]
): Promise<Blob> {
  try {
    // Convert files to the format expected by client-zip
    const stream = (await makeZip(files));
    const blob = await ((new Response(stream)).blob());
    return blob;
  } catch (error) {
    console.error('Error creating zip file:', error);
    throw error;
  }
}

export async function downloadMultipleFilesAsZip(
  files: Array<{
    buffer: ArrayBuffer | Uint8Array | Blob;
    fileName: string;
    mimeType?: string;
  }>,
  zipFileName?: string
) {
  try {
    // Convert files to the format expected by client-zip
    const zipFiles = files.map(file => ({
      name: file.fileName,
      input: file.buffer,
      ...(file.mimeType && { type: file.mimeType })
    }));

    // Generate and download the zip file
    const blobResponse = await downloadZip(zipFiles);

    // Create a download link
    const url = URL.createObjectURL(await blobResponse.blob());
    const a = document.createElement('a');
    a.href = url;
    a.download = zipFileName ?? 'download.zip';
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();

    // Cleanup
    window.addEventListener(
      'focus',
      () => {
        URL.revokeObjectURL(url);
        document.body.removeChild(a);
      },
      { once: true }
    );
  } catch (error) {
    console.error('Error generating zip file:', error);
    throw error;
  }
}
